import React from 'react';
import { ParallaxSection } from '../components/ParallaxSection';
import { SectionHeading } from '../components/SectionHeading';
const staff = [{
  name: 'Jennifer Wu',
  title: 'Operations Director',
  image: 'https://images.unsplash.com/photo-1598550874175-4d7112ee7f43?w=400&q=80'
}, {
  name: 'Mark Thompson',
  title: 'Senior Estimator',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&q=80'
}, {
  name: 'Lisa Anderson',
  title: 'HR Manager',
  image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&q=80'
}, {
  name: 'Robert Martinez',
  title: 'Site Superintendent',
  image: 'https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?w=400&q=80'
}, {
  name: 'Emily Parker',
  title: 'Client Relations',
  image: 'https://images.unsplash.com/photo-1554151228-14d9def656ec?w=400&q=80'
}, {
  name: 'Thomas Wright',
  title: 'Logistics Coordinator',
  image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&q=80'
}];
export function StaffPage() {
  return <div className="bg-white min-h-screen" data-id="element-279" data-mp="2zxy9dspfhfbz">
      <ParallaxSection backgroundImage="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1920&q=80" height="h-[50vh]" data-id="element-280" data-mp="3dvwm6to3p3pd">
        <h1 className="text-5xl md:text-7xl font-bold font-serif text-white text-center" data-id="element-281" data-mp="38vqoavr8mkyu">
          Our Staff
        </h1>
      </ParallaxSection>

      <section className="py-20 px-4 md:px-8" data-id="element-282" data-mp="3ivhn39mtzm4q">
        <div className="max-w-7xl mx-auto" data-id="element-283" data-mp="3iupwyec06glu">
          <SectionHeading title="The Team" subtitle="The dedicated professionals ensuring your project's success." data-id="element-284" data-mp="h08fgk16qaw" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-285" data-mp="3slkmpsogjyc1">
            {staff.map((member, index) => <div key={index} className="flex items-center gap-6 p-6 bg-gray-50 rounded-sm hover:bg-white hover:shadow-lg transition-all duration-300 border border-transparent hover:border-gray-100" data-id="element-286" data-mp="ad388freucuo" data-mpi={index}>
                <img src={member.image} alt={member.name} className="w-24 h-24 rounded-full object-cover border-2 border-[#C5A55A]" data-id="element-287" data-mp="33ay1wvg1l90x" />
                <div data-id="element-288" data-mp="3d0hmq6nbfcyf">
                  <h3 className="text-xl font-bold font-serif text-black" data-id="element-289" data-mp="3d10uwvn5ymz9">
                    {member.name}
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-290" data-mp="3mxvtfejfsndj">{member.title}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
}